module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/thumbs/1-1acd64ce318658d829115ec0344e8810.webp";